import clsx from 'clsx';
import type { ReactNode } from 'react';
import { chatStyles } from '@/shared/ui/chat/styles';

export function PromoActions({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	return <div className={clsx(chatStyles.actions, className)}>{children}</div>;
}
